import * as React from 'react';
import { useSelector } from 'react-redux';
import { Base, DrawerFooter } from '@gandi/ui';
import CartContentContext from '../../CartContentContext';
import CheckoutButton from '../../CheckoutButton';
import { selectCountItems } from '../../modules/selectors';
import PricesIndicator from './PricesIndicator';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function Footer() {
  const {
    noCheckoutButton
  } = React.useContext(CartContentContext);
  const count = useSelector(selectCountItems);
  return /*#__PURE__*/_jsxs(DrawerFooter, {
    paddingBottom: "small",
    children: [!noCheckoutButton && count > 0 && /*#__PURE__*/_jsx(Base, {
      position: "relative",
      children: /*#__PURE__*/_jsx(CheckoutButton, {})
    }), /*#__PURE__*/_jsx(Base, {
      flex: true,
      flexJustifyCenter: true,
      children: /*#__PURE__*/_jsx(PricesIndicator, {})
    })]
  });
}
export default Footer;